import { render, staticRenderFns } from "./r-piggy-mechanic-type.vue?vue&type=template&id=57b27c5a"
import script from "./r-piggy-mechanic-type.vue?vue&type=script&lang=js"
export * from "./r-piggy-mechanic-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b27c5a')) {
      api.createRecord('57b27c5a', component.options)
    } else {
      api.reload('57b27c5a', component.options)
    }
    module.hot.accept("./r-piggy-mechanic-type.vue?vue&type=template&id=57b27c5a", function () {
      api.rerender('57b27c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-piggy/r-piggy-mechanic-type.vue"
export default component.exports